module.exports = {
      id: "shortform-usage",
      viewBox: "0 0 13.07 13.758",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#shortform",
      toString: function () {
        return this.url;
      }
    }